/**
 * SCRIPT INJECTION FOR WEB ORDERING APP
 *
 * Poligon Central location:
 * "Web ordering app" -> Script Injection
 */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'scriptInjection',
  initialState: null as null | string,
  reducers: {
    setScriptInjection(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setScriptInjection } = slice.actions;

export default slice.reducer;
